import axios from "axios";  
import { BASE_URL } from "../../assets/constants";
import { createFormHeaders, createHeaders } from "../../utils/Utils";

//! Dashboard APIs
 
//  Get Dashboard Orders Table Data
export const getDashboardOrdersAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}dashboard-order-table`, data, headers );
};
//  Get Dashboard Orders Details
export const getOrdersDetailsAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}order-details`, data, headers );
};
//! Bulk Orders List APIs
//  Get Dashboard Orders Table Data
export const getBulkOrdersAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}admin-list-bulkOrder`, data, headers );
};
 